import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ForgotPassword from "./component/auth/ForgotPassword";
import Login from "./component/auth/Login";
import ResetPassword from "./component/auth/ResetPassword";
import Agents from "./component/utilities/agents/Agents";
import CrateSuppliers from "./component/utilities/crateSupplier/CrateSuppliers";
import EditCrateSupplier from "./component/utilities/crateSupplier/EditCrateSupplier";
import InsertCrateSupplier from "./component/utilities/crateSupplier/InsertCrateSupplier";
import Categories from "./component/utilities/catagory/Categories";
import EditCatagory from "./component/utilities/catagory/EditCatagory";
import InsertCatagory from "./component/utilities/catagory/InsertCatagory";
import Containers from "./component/utilities/containers/Containers";
import EditContainer from "./component/utilities/containers/EditContainer";
import InsertContainer from "./component/utilities/containers/InsertContainer";
import EditProduct from "./component/utilities/products/EditProduct";
import InsertProduct from "./component/utilities/products/InsertProduct";
import Products from "./component/utilities/products/Products";
import EditUnit from "./component/utilities/units/EditUnit";
import InsertUnit from "./component/utilities/units/InsertUnit";
import Units from "./component/utilities/units/Units";
import VegArt from "./component/VegArt";
import Customers from "./component/utilities/customer/Customers";
import InsertCustomer from "./component/utilities/customer/InsertCustomer";
import EditCustomer from "./component/utilities/customer/EditCustomer";
import InsertAgent from "./component/utilities/agents/InsertAgent";
import EditAgent from "./component/utilities/agents/EditAgent";
import UsersList from "./component/users/UsersList";
import EditUser from "./component/users/EditUser";
import InsertUser from "./component/users/InsertUser";
import MyAccount from "./component/MyAccount";
import ChangePassword from "./component/ChangePassword";
import AuthProvider from "./providers/AuthProvider";
import useAuth from "./hooks/useAuth";
import AllOrders from "./component/orders/AllOrders";
import EnterOrder from "./component/orders/EnterOrder";
import PrintOrders from "./component/orders/PrintOrders";
import EnterBuyingPrice from "./component/orders/EnterBuyingPrice";
import FinaliseOrder from "./component/orders/FinaliseOrder";
import PrintSheet from "./component/orders/PrintSheet";
import ViewEditOrder from "./component/orders/ViewEditOrder";
import OnHandOrder from "./component/orders/OnHandOrder";
import CrateCredit from "./component/credits/CrateCredit";
import ProduceCredit from "./component/credits/ProduceCredit";
import AllProduceCredits from "./component/credits/AllProduceCredits";
import AllCrateCredits from "./component/credits/AllCrateCredits";
import ViewEditCrateCredit from "./component/credits/ViewEditCrateCredit";
import ViewEditProduceCredit from "./component/credits/ViewEditProduceCredit";
import AllInvoices from "./component/credits/AllInvoices";
import AmendInvoice from "./component/credits/AmendInvoice";
import AllSheetsEmail from "./component/Email/AllSheetsEmail";

export function App() {
  const PublicRoute = ({ children }) => {
    let auth = useAuth();

    if (auth.user) {
      return <Navigate to="/veg-art" replace />;
    }

    return children;
  };
  const PrivateRoute = ({ children }) => {
    let auth = useAuth();

    if (!auth.user) {
      return <Navigate to="/" replace />;
    }
    return children;
  };
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/sheet-email/:type/:id/:date"
          element={
            <PublicRoute>
              <AllSheetsEmail />
            </PublicRoute>
          }
        />
        <Route
          path="/veg-art"
          element={
            <PrivateRoute>
              <VegArt />
            </PrivateRoute>
          }
        />
        <Route
          path="/units"
          element={
            <PrivateRoute>
              <Units />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-unit"
          element={
            <PrivateRoute>
              <InsertUnit />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-unit/:id"
          element={
            <PrivateRoute>
              <EditUnit />
            </PrivateRoute>
          }
        />
        <Route
          path="/containers"
          element={
            <PrivateRoute>
              <Containers />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-container"
          element={
            <PrivateRoute>
              <InsertContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-container/:id"
          element={
            <PrivateRoute>
              <EditContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/products"
          element={
            <PrivateRoute>
              <Products />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-product"
          element={
            <PrivateRoute>
              <InsertProduct />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-product/:id"
          element={
            <PrivateRoute>
              <EditProduct />
            </PrivateRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <PrivateRoute>
              <Categories />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-category"
          element={
            <PrivateRoute>
              <InsertCatagory />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-category/:id"
          element={
            <PrivateRoute>
              <EditCatagory />
            </PrivateRoute>
          }
        />
        <Route
          path="/crate-suppliers"
          element={
            <PrivateRoute>
              <CrateSuppliers />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-crate-supplier"
          element={
            <PrivateRoute>
              <InsertCrateSupplier />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-crate-supplier/:id"
          element={
            <PrivateRoute>
              <EditCrateSupplier />
            </PrivateRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <PrivateRoute>
              <Customers />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-customer"
          element={
            <PrivateRoute>
              <InsertCustomer />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-customer/:id"
          element={
            <PrivateRoute>
              <EditCustomer />
            </PrivateRoute>
          }
        />
        <Route
          path="/agents"
          element={
            <PrivateRoute>
              <Agents />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-agent"
          element={
            <PrivateRoute>
              <InsertAgent />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-agent/:id"
          element={
            <PrivateRoute>
              <EditAgent />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UsersList />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-user"
          element={
            <PrivateRoute>
              <InsertUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-user/:id"
          element={
            <PrivateRoute>
              <EditUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-account"
          element={
            <PrivateRoute>
              <MyAccount />
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ChangePassword />
            </PrivateRoute>
          }
        />
        <Route
          path="/all-orders"
          element={
            <PrivateRoute>
              <AllOrders />
            </PrivateRoute>
          }
        />
        <Route
          path="/enter-order"
          element={
            <PrivateRoute>
              <EnterOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/print-order"
          element={
            <PrivateRoute>
              <PrintOrders />
            </PrivateRoute>
          }
        />
        <Route
          path="/enter-buying-price"
          element={
            <PrivateRoute>
              <EnterBuyingPrice />
            </PrivateRoute>
          }
        />
         <Route
          path="/on-hand-order"
          element={
            <PrivateRoute>
              <OnHandOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/finalise-order"
          element={
            <PrivateRoute>
              <FinaliseOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/print-sheet"
          element={
            <PrivateRoute>
              <PrintSheet />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-edit-order/:id"
          element={
            <PrivateRoute>
              <ViewEditOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/crate-credits"
          element={
            <PrivateRoute>
              <CrateCredit />
            </PrivateRoute>
          }
        />
         <Route
          path="/produce-credits"
          element={
            <PrivateRoute>
              <ProduceCredit />
            </PrivateRoute>
          }
        />
        <Route
          path="/all-produce-credits"
          element={
            <PrivateRoute>
              <AllProduceCredits />
            </PrivateRoute>
          }
        />
          <Route
          path="/all-crate-credits"
          element={
            <PrivateRoute>
              <AllCrateCredits />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-edit-crate-credit/:id"
          element={
            <PrivateRoute>
              <ViewEditCrateCredit />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-edit-produce-credit/:id"
          element={
            <PrivateRoute>
              <ViewEditProduceCredit />
            </PrivateRoute>
          }
        />
         <Route
          path="/all-invoices"
          element={
            <PrivateRoute>
              <AllInvoices />
            </PrivateRoute>
          }
        />
          <Route
          path="/amend-invoice/:id"
          element={
            <PrivateRoute>
              <AmendInvoice />
            </PrivateRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
